import { actions } from './actions'

const initialState = {
  data: [],
}

export default function exercisesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_EXERCISES_RESULT:
      return { ...state, data: action.payload.data }
    default:
      return state
  }
}
